const PDF_URL_REVOKE_DELAY_MS = 60000;

const createPdfObjectUrl = (pdfBase64: string): string => {
  const binary = atob(pdfBase64.replace(/\s/g, ''));
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);

  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }

  const blob = new Blob([view], { type: 'application/pdf' });

  return window.URL.createObjectURL(blob);
};

/**
 * Open PDF in a new window/tab.
 */
export const openPdfInNewWindow = (
  pdfBase64: string,
  filename?: string
): void => {
  const url = createPdfObjectUrl(pdfBase64);
  const pdfWindow = window.open(url, '_blank');

  if (pdfWindow && filename) {
    try {
      pdfWindow.document.title = filename;
    } catch {
      // Some browser PDF viewers restrict document access after navigation.
    }
  }

  window.setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, PDF_URL_REVOKE_DELAY_MS);
};
